import type { MathChange } from './changesApi';

/** Сообщение для WhatsApp: какие аптеки должны сдать мат. отчет повторно */
export function buildWhatsAppMessage(changes: MathChange[]): string {
  const pharmacies = changes.map((item) => item.pharmacyNum).join(', ');
  return `Следующие аптеки должны сдать мат. отчет ещё раз, в срочном порядке:\n${pharmacies}`;
}
